import { convertToURLSearchParams } from "@/util";

const BASE_PATH = "/williams";

export const routes = {
  home: BASE_PATH,
  dashboard: {
    base: "dashboard",
    view: (view: string) => `dashboard/${view}`,
  },
  project: {
    list: "projects",
    create: "project/new",
    open: (id: string) => `project/${id}`,
    edit: (id: string) => `project/edit/${id}`,
  },
  scopeOfWork: {
    create: "scope/new",
    open: (id: string) => `scope/${id}`,
    list: (view?: string) => `scopes/${view ?? ""}`,
  },
  testEvent: {
    list: "events",
    create: "event/new",
    open: (id: string) => `event/${id}`,
    results: (id: string) => `event/${id}/results`,
  },
  standardTests: {
    list: "tests",
    create: "test/new",
    open: (id: string) => `test/${id}`,
  },
  welder: {
    create: "welder/new",
    open: (id: string) => `welder/${id}`,
    edit: (id: string) => `welder/edit/${id}`,
    list: (view?: string) => `welders/${view ?? ""}`,
    renewal: "welders/renewal",
  },
  contractor: {
    list: "contractors",
    create: "contractors/new",
    open: (id: string) => `contractor/${id}`,
    edit: (id: string) => `contractor/edit/${id}`,
  },
  user: {
    transferOwnership: "transfer/ownership",
    transferSpecialist: "transfer/tier2",
  },
  miscellaneous: {
    help: "help",
    settings: "settings",
    search: "search",
    weldingSpecialists: "welding-specialists",
    notfound: "404",
  },
};

export const getFullPath = (path: string, params?: Record<string, string | undefined>) => {
  if (params) {
    return `${BASE_PATH}/${path}?${convertToURLSearchParams(params)}`;
  } else {
    return `${BASE_PATH}/${path}`;
  }
};
